import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/login/Login3'
import Home from '@/components/home/HomeV2.vue'
import Register from '@/components/login/Register.vue'
Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      children: [
        // 日志管理
        {
          path: '/log',
          name: 'Log',
          component: () => import('@/components/log/Log')
        },
        // 项目管理
        {
          path: '/project',
          name: 'Project',
          component: () => import('@/components/project/Project')
        },
        {
          path: '/contactPerson',
          name: 'ContactPerson',
          component: () => import('@/components/contactPerson/ContactPerson')
        },
        {
          path: '/summaryBurner',
          name: 'SummaryBurner',
          component: () => import('@/components/smalltools/SummaryBurner')
        },
        {
          path: '/fileAnswer',
          name: 'FileAnswer',
          component: () => import('@/components/smalltools/FileAnswer')
        },
        {
          path: '/loveLog',
          name: 'LoveLog',
          component: () => import('@/components/lovelog/LoveLog.vue')
        }
      ]
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js